import React, { useEffect, useRef, useState } from 'react'
import kingdomImg from '../../assets/logo_kingdom_256px.png';
import MsgUtils from '../Tools/MsgUtils';
import ReCAPTCHA from "react-google-recaptcha";
import ModalCargando from '../utilsComponentes/ModalCargando';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
const server = process.env.REACT_APP_SERVER;
function ReclutamientoPersonal() {
    const [regional, setRegional] = useState('');
    const [loading, setLoading] = useState(false);
    const [datos, setDatos] = useState([]);
    const [nombre, setNombre] = useState('');
    const [ci, setCi] = useState('');
    const [genero, setGenero] = useState('');
    const [edad, setEdad] = useState(0);
    const [direccion, setDireccion] = useState('');
    const [idZona, setIdZona] = useState(0);
    const [numero, setNumero] = useState(0);
    const [celular, setCelular] = useState(0);
    const [idCargo, setIdCargo] = useState(0);
    const [error, setError] = useState({});
    const [maxCupos, setMaxCupos] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [isFull,setIsFull] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [resultado, setResultado] = useState({});
    const [idHora, setIdHora] = useState(0);
    const [horarios, setHorarios] = useState([]);
    const [tieneHora, setTieneHora] = useState(false);
    const [idAdjunto, setIdAdjunto] = useState(0);
    const [idAdjuntoDoc, setIdAdjuntoDoc] = useState(0);
    const [validoCaptcha, setValidoCaptcha] = useState(null);
    const [previewVideo, setPreviewVideo] = useState(null);
    const [idAdjuntoVideo, setIdAdjuntoVideo] = useState(-1);
    const captchat = useRef(null);
    const onChange = () => {
        if (captchat.current.getValue() != '') {
            setValidoCaptcha(true);
        } else {
            setValidoCaptcha(false);
        }
    }
    function limpiarDatos() {
        captchat.current.reset();
        setNombre('');
        setCi('');
        setIdAdjuntoDoc(0);
        setGenero(''); setEdad(0); setDireccion(''); setIdZona(0);
        setNumero(''); setCelular(''); setIdCargo(0); setIdHora(0); setIdAdjunto(0);
        document.getElementById('blah').src = '';
    }
    function validarInfo() {
        var horav = true
        if (tieneHora == true) {
            horav = (idHora != 0);
        }
        if (captchat.current.getValue() != '') {
            if (nombre !== '' && ci !== '' && genero !== '' && edad > 0 && idZona !== 0 && idCargo !== 0 && direccion != '' && horav && idAdjunto != 0 && idAdjuntoDoc!=0) {
                if (nombre.length >= 3) {
                    if (edad >= 18) {
                        if (numero != 0 || celular != 0) {
                            if (numero != 0) {
                                if (numero.length == 7) {
                                    var nums = numero.toString()
                                    console.log(nums[0], regional)
                                    if (regional == '990') {
                                        if (nums[0] == '4') {
                                            setError({})
                                            return true
                                        } else {
                                            setError({ 'cmptelefono': 'Número de telefono, no es de su ciudad ...' })
                                            return false
                                        }
                                    } else {
                                        if (nums[0] == '3') {
                                            setError({})
                                            return true
                                        } else {
                                            setError({ 'cmptelefono': 'Número de telefono, no es de su ciudad ...' })
                                            return false
                                        }
                                    }
                                } else {
                                    setError({ 'cmptelefono': 'Número de telefono, invalido ...' })
                                    return false
                                }
                            } else if (celular != 0) {
                                if (celular.length == 8) {
                                    if (celular[0] == '6' || celular[0] == '7') {
                                        setError({})
                                        return true
                                    } else {
                                        setError({ 'cmpcelular': 'Número de celular invalido ...' })
                                        return false
                                    }
                                } else {
                                    setError({ 'cmpcelular': 'Número de celular invalido ...' })
                                    return false
                                }
                            }
                        } else {
                            setError({ 'cmpnum': 'Por lo menos uno es requerido' });
                            return false;
                        }
                    } else {
                        setError({ "cmpedad": 'Tiene que ser mayor de edad pora favor.' })
                        return false;
                    }
                } else {
                    setError({ 'cmpname': 'Coloca su nombre completo' })
                    return false;
                }
            } else {
                captchat.current.reset();
                setError({ 'cmpreq': 'Este campo es requerido' });
                MsgUtils.msgError("Completa los campos requeridos")
                return false;
            }
        } else {
            setValidoCaptcha(false);
        }
    }
   function enviarRegistro() {

        if (validarInfo()) {
            setLoading(true);

            fetch(`${server}/formulario/addInfoReclutamiento`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional: regional,
                    ci,
                    nombre,
                    edad,
                    genero,
                    direccion,
                    idZona,
                    idCargo,
                    numero,
                    celular,
                    idHora,
                    idAdjunto,
                    idAdjuntoDoc,
                    idAdjuntoVideo
                })
            })
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                setResultado(data);
                setModalShow(true);

                console.log("CLICK EN ENVIAR 2");

                if (data.ok) {
                    setMaxCupos(maxCupos + 1);
                    MsgUtils.msgCorrecto(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => {
                setLoading(false);

                console.log("ERROR COMPLETO:", err);
                console.log("MENSAJE:", err.message);

                MsgUtils.msgError(
                    err?.response?.data?.error ||
                    err?.message ||
                    "Error inesperado"
                );
            });
        }
    }
    function obtenerDatos(regi) {
        setLoading(true);
        fetch(`${server}/formulario/getInfoReclutamiento`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'regional': regi
            })
        })
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                //setResultado(data);
                if (data.ok) {
                    console.log(data.ok)
                    var postulacionesCont = data.ok.cargo.map(item=>item.MAXIMO)
                    var postulacionesRealizadas = postulacionesCont.reduce((a, b) => a + b, 0);
                    console.log(postulacionesRealizadas)
                    setResultado({});
                    setDatos(data.ok);
                    for (var i of data.ok.cupos) {
                        if (i.CAMPO == "POSTULACIONES_CUPOS") {
                            setMaxCupos(i.DATO_FLOAT)
                            if(postulacionesRealizadas==i.DATO_FLOAT){
                                setIsFull(true);
                            }else{
                                setIsFull(false);
                            }
                        } else if (i.CAMPO == "POSTULACIONES_ABIERTAS") {
                            if (i.DATO_CADENA == 'N') {
                                setIsOpen(false);
                            } else if (i.DATO_CADENA == 'S') {
                                setIsOpen(true);
                            }
                        }
                    }
                } else {
                    setModalShow(true);
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => MsgUtils.msgError(err));
    }
    function elegirCargo(valor) {
        var hor = datos.cargo.filter((item) => item.ID_CARGO == valor)
        if (hor.length != 0) {
            if (hor[0].HORARIOS.length != 0) {
                setHorarios(hor[0].HORARIOS);
                setTieneHora(true);
            } else {
                setTieneHora(false);
                setHorarios([])
            }
        } else {
            setTieneHora(false);
            setHorarios([])
        }
        setError({});
        setIdCargo(parseInt(valor));
    }
    const cargarFoto = (e) => { 
        setLoading(true);
        var archiv = e.target.files[0];
        //console.log(archiv);
        var id = -9;
        var formData = new FormData()
        formData.append('FILE1', new Blob([archiv], { contentType: 'application/octet-stream', contentTransferEncoding: 'binary' }), archiv.name + '.' + id);
        try {
            var ipPublica = regional == '990' ? 'https://archivos.chickenskingdom.com' : 'https://ra.chickenskingdom.com'
            axios.post(`${ipPublica}`, formData, {
                'Accept': 'application/json',
                'content-type': 'multipart/form-data'
            }).then(res => {
                if (parseInt(res.data) != 0) {
                    setIdAdjunto(res.data)
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        document.getElementById('blah').src = e.target.result;
                    };
                    reader.readAsDataURL(e.target.files[0]);
                } else {
                    MsgUtils.msgError("Intente Nuevamente, No pude obtener su foto...")
                }
                setLoading(false);
            }).catch(error => {
                MsgUtils.msgError("INTENTE Nuevamente ...");
                setLoading(false);
            })
        } catch (error) {
            console.error('Error al subir el archivo !!');
        }
     }

    const cargarVideo = (e) => {
        setLoading(true);
        const archiv = e.target.files[0];
        if (!archiv) return;
        // Validación de tamaño (20 MB)
        if (archiv.size > 20 * 1024 * 1024) {
            MsgUtils.msgError("El video es muy pesado. Máximo 20MB.");
            setLoading(false);
            return;
        }
        const id = -9;
        const formData = new FormData();
        formData.append(
            'FILE1',
            new Blob(
                [archiv],
                {
                    contentType: 'application/octet-stream',
                    contentTransferEncoding: 'binary'
                }
            ),
            archiv.name + '.' + id
        );
        try {
            const ipPublica = regional === '990'
                ? 'https://archivos.chickenskingdom.com'
                : 'https://ra.chickenskingdom.com';

            axios.post(ipPublica, formData, {
                headers: {
                    'Accept': 'application/json',
                    'content-type': 'multipart/form-data'
                }
            })
            .then(res => {
                const resId = parseInt(res.data);
                if (resId !== 0 && !isNaN(resId)) {
                    // Guardar ID igual que foto
                    setIdAdjuntoVideo(resId);
                    // Vista previa del video
                    const videoUrl = URL.createObjectURL(archiv);
                    setPreviewVideo(videoUrl);
                    MsgUtils.msgCorrecto("Video cargado correctamente");

                } else {
                    MsgUtils.msgError("Intente nuevamente, no pude obtener el video...");
                }
                setLoading(false);
            })
            .catch(error => {
                console.error(error);
                MsgUtils.msgError("INTENTE nuevamente...");
                setLoading(false);
            });
        } catch (error) {
            console.error('Error al subir el video:', error);
            setLoading(false);
        }
    }

    const cargarDocumento = (e) => {
        var archiv = e.target.files[0];
        if (parseInt(archiv.size / 1000000) <= 30) {
            setLoading(true);
            var id = -9;
            var formData = new FormData()
            formData.append('FILE1', new Blob([archiv], { contentType: 'application/octet-stream', contentTransferEncoding: 'binary' }), archiv.name + '.' + id);
            try {
                var ipPublica = regional == '990' ? 'https://archivos.chickenskingdom.com' : 'https://ra.chickenskingdom.com'
                axios.post(`${ipPublica}`, formData, {
                    'Accept': 'application/json',
                    'content-type': 'multipart/form-data'
                }).then(res => {
                    if (parseInt(res.data) != 0) {
                        setIdAdjuntoDoc(res.data);
                    } else {
                        MsgUtils.msgError("Intente Nuevamente, No pude obtener su foto...")
                    }
                    setLoading(false);
                }).catch(error => {
                    MsgUtils.msgError("INTENTE Nuevamente ...");
                    setLoading(false);
                })
            } catch (error) {
                console.error('Error al subir el archivo !!');
            }
        } else {
            MsgUtils.msgError("La hoja de vida tiene que pesar menor o igual a 30Megas, por favor")
        }
    }
    useEffect(() => {
        var dato = window.location.pathname.split('/');
        if (dato[2] == 'cbba') {
            setRegional('990')
            obtenerDatos('990')
        } else if (dato[2] == 'scrz') {
            setRegional('991')
            obtenerDatos('991')
        } else {
            MsgUtils.msgError("Error con la ciudad")
        }
    }, [])
    return (
        <>
            <div className="navbar navbar-dark bg-dark m-0 p-0 py-1">
                <div className="container-fluid ">
                    <div className="navbar-brand card flex-row bg-dark m-0 p-0" >
                        <img src={kingdomImg} width="50" className="d-inline-block align-text-top card-img-left my-auto" />
                        <div className='ps-2 my-auto d-none d-sm-inline'>
                            <div className="cargoHeader lh-sm">Chicken's<br></br>Kingdom</div>
                        </div>
                    </div>
                    <div className='text-light fw-bold fs-6 text-uppercase'>Formulario Reclutamiento</div>
                </div>
            </div>
            {/** 
             isOpen == true && isFull==false&&<div className='container-fluid  py-2'>
                <div className="card bg-dark bg-gradient text-light" >
                    <div className="card-body">
                        <div className="mb-3">
                            <div className='row row-cols g-1 gx-1'>
                                <div className='col col-9'>
                                    <label className="form-label" ><i className="fa-solid fa-address-card"></i> Documento de Identidad</label>
                                    <input type="text" className="form-control" value={ci} 
                                        onChange={(e) => { 
                                            if(e.target.value.length<20){
                                                setCi(e.target.value); 
                                                setError({}); 
                                            }else{
                                                MsgUtils.msgAdvertencia("solo permitimos 20 caracteres")
                                            }
                                        }} />
                                    {error.cmpreq !== undefined && ci == '' && <div className="alert alert-danger m-0 p-0" >
                                        {error.cmpreq}
                                    </div>}
                                </div>
                                <div className='col col-3 text-center'>
                                    {idAdjunto == 0 && <label className='btn fs-1 text-success'>
                                        <i className="fa-solid fa-image"></i>
                                        <input type="file" accept='image/jpeg' onChange={(e) => cargarFoto(e, 1)} />
                                    </label>}
                                    <img id="blah" src="" width={80} />
                                    {error.cmpreq !== undefined && idAdjunto == 0 && <div className="alert alert-danger m-0 p-0" >
                                        {error.cmpreq}
                                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className="mb-3">
                            <label className="form-label"><i className="fa-solid fa-user"></i> Nombre Completo</label>
                            <input type="text" className="form-control" value={nombre} 
                                onChange={(e) => { 
                                    if(e.target.value.length<100){
                                        setError({}); 
                                        setNombre(e.target.value.toUpperCase()) 
                                    }else{
                                        MsgUtils.msgAdvertencia("solo se permite 100 caracteres")
                                    }
                                }} />
                            {error.cmpreq !== undefined && nombre == '' && <div className="alert alert-danger m-0 p-0" >
                                {error.cmpreq}
                            </div>}
                            {error.cmpname !== undefined && <div className="alert alert-danger m-0 p-0" >
                                {error.cmpname}
                            </div>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label"><i className="fa-solid fa-venus-mars"></i> Genero</label>
                            <select className="form-select" value={genero} onChange={(e) => { setError({}); setGenero(e.target.value) }}>
                                <option selected value={''}>Elija una Genero</option>
                                <option value={'M'}>Masculino</option>
                                <option value={'F'}>Femenino</option>
                            </select>
                            {error.cmpreq !== undefined && genero == '' && <div className="alert alert-danger m-0 p-0" >
                                {error.cmpreq}
                            </div>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label"><i className="fa-solid fa-handshake-simple"></i> Edad</label>
                            <input type="number" className="form-control" value={edad} onChange={(e) => { setError({}); setEdad(e.target.value) }} />
                            {error.cmpreq !== undefined && edad == 0 && <div className="alert alert-danger m-0 p-0" >
                                {error.cmpreq}
                            </div>}
                            {error.cmpedad !== undefined && edad < 18 && <div className="alert alert-danger m-0 p-0" >
                                {error.cmpedad}
                            </div>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label"><i className="fa-solid fa-globe"></i> Zona</label>
                            <select className="form-select" value={idZona} onChange={(e) => { setError({}); setIdZona(e.target.value) }}>
                                <option selected value={0}>Elija una Zona</option>
                                {datos.zonas != undefined &&
                                    datos.zonas.map((item, index) => {
                                        return (<option value={item.ID_ZONA} key={index}>{item.DESCRIPCION}</option>)
                                    })}
                            </select>
                            {error.cmpreq !== undefined && idZona == 0 && <div className="alert alert-danger m-0 p-0" >
                                {error.cmpreq}
                            </div>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label"><i className="fa-solid fa-tty"></i> Número Fijo</label>
                            <input type="number" className="form-control" value={numero} onChange={(e) => { setError({}); setNumero(e.target.value) }} />
                            {error.cmpnum !== undefined && numero == 0 && <div className="alert alert-danger m-0 p-0" >
                                {error.cmpnum}
                            </div>}
                            {error.cmptelefono !== undefined && <div className="alert alert-danger m-0 p-0" >
                                {error.cmptelefono}
                            </div>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label"><i className="fa-solid fa-mobile-screen-button"></i> Numero Celular</label>
                            <input type="number" className="form-control" value={celular} onChange={(e) => { setError({}); setCelular(e.target.value) }} />
                            {error.cmpnum !== undefined && celular == 0 && <div className="alert alert-danger m-0 p-0" >
                                {error.cmpnum}
                            </div>}
                            {error.cmpcelular !== undefined && <div className="alert alert-danger m-0 p-0" >
                                {error.cmpcelular}
                            </div>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label"><i className="fa-solid fa-person-walking-luggage"></i> Cargo</label>
                            <select className="form-select" value={idCargo} onChange={(e) => elegirCargo(e.target.value)}>
                                <option value={0}>Elija un cargo</option>
                                {datos.cargo != undefined &&
                                    datos.cargo.map((item, index) => {
                                        return (<option value={item.ID_CARGO} key={index}>{item.DESCRIPCION}</option>)
                                    })}
                            </select>
                            {error.cmpreq !== undefined && idCargo == 0 && <div className="alert alert-danger m-0 p-0" >
                                {error.cmpreq}
                            </div>}
                        </div>
                        {horarios.length != 0 && <div className="mb-3">
                            <label className="form-label"><i className="fa-solid fa-clock"></i> Horario</label>
                            <select className="form-select" value={idHora} onChange={(e) => setIdHora(e.target.value)}>
                                <option selected value={0}>Elija un Horario</option>
                                {horarios.map((item, index) => {
                                    return (<option value={item.ID_HORARIO} key={index}>{item.DESCRIPCION}</option>)
                                })}
                            </select>
                            {error.cmpreq !== undefined && idHora == 0 && <div className="alert alert-danger m-0 p-0" >
                                {error.cmpreq}
                            </div>}
                        </div>}
                        <div className="mb-3">
                            <label className="form-label"><i className="fa-solid fa-address-book"></i> Dirección</label>
                            <textarea className='form-control' value={direccion} 
                                onChange={(e) => { 
                                    if(e.target.value.length<200){
                                        setError({}); 
                                        setDireccion(e.target.value.toLocaleUpperCase()) 
                                    }else{
                                        MsgUtils.msgAdvertencia("Solo permitimos 200 caracteres")
                                    }
                                }}></textarea>
                            {error.cmpreq !== undefined && direccion == '' && <div className="alert alert-danger m-0 p-0" >
                                {error.cmpreq}</div>}
                        </div>
                        <div className='btn-group'>
                            <div><label className="form-label"><i className="fa-solid fa-file-pdf"></i> Hoja de Vida</label></div>
                            {idAdjuntoDoc==0&&<div className='m-0 p-0'>
                                <label className='btn fs-1 text-success lh-1'>
                                    <i className="fa-solid fa-file-pdf"></i>
                                    <input type="file" accept='application/pdf' onChange={(e) => cargarDocumento(e, 1)} />
                                </label>
                            </div>}
                            {idAdjuntoDoc!==0&&<button className='btn btn-sm btn-danger mx-2' onClick={()=>setIdAdjuntoDoc(0)}><i className="fa-solid fa-trash-can"></i></button>}
                            {error.cmpreq !== undefined && idAdjuntoDoc == 0 && <div className="alert alert-danger m-0 p-0" >
                                {error.cmpreq}</div>}
                        </div>
                        <div className="forms-inputs mx-auto text-center">
                            <ReCAPTCHA
                                ref={captchat}
                                className="g-recaptcha"
                                theme="dark"
                                sitekey="6LcktxUgAAAAAI7TXwwBes8u9bz79PnCsweM6IL0"
                                onChange={onChange}
                            />
                            {validoCaptcha === false && <div className="badge bg-danger text-wrap">
                                Valida el captchat antes por favor...
                            </div>}
                        </div>
                        {validoCaptcha == true && <button className='btn btn-sm btn-success w-100' onClick={() => enviarRegistro()}><i className="fa-solid fa-paper-plane"></i> Enviar</button>}
                    </div>
                </div>
            </div>
*/}
            {isOpen === true && isFull === false && (
                <div className='container py-4'>
                    <div className="card shadow-lg border-0 bg-dark text-light" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                    
                    {/* Header del Formulario */}
                    <div className="card-header bg-secondary bg-opacity-25 border-bottom border-secondary py-3">
                        <h5 className="card-title mb-0 text-center text-uppercase fw-bold">
                        <i className="fa-solid fa-file-signature me-2"></i> Registro de Postulante
                        </h5>
                    </div>

                    <div className="card-body p-4">
                        <div className="row g-3">
                        
                        {/* Documento y Foto */}
                        <div className="col-md-9">
                            <label className="form-label fw-bold text-info"><i className="fa-solid fa-address-card"></i> Documento de Identidad</label>
                            <input 
                            type="text" 
                            className={`form-control form-control-lg bg-dark text-light border-secondary ${error.cmpreq && !ci ? 'is-invalid' : ''}`}
                            placeholder="Ej: 1234567"
                            value={ci} 
                            onChange={(e) => { 
                                if(e.target.value.length < 20){ setCi(e.target.value); setError({}); }
                                else { MsgUtils.msgAdvertencia("Máximo 20 caracteres") }
                            }} 
                            />
                            {error.cmpreq && !ci && <div className="invalid-feedback">{error.cmpreq}</div>}
                        </div>

                        <div className='col-md-3 text-center d-flex flex-column align-items-center justify-content-center'>
                            <div className="position-relative">
                            {idAdjunto == 0 ? (
                                <label className='btn btn-outline-success d-flex flex-column align-items-center p-3'>
                                <i className="fa-solid fa-camera fs-3 mb-1"></i>
                                <small>Subir Foto</small>
                                <input type="file" hidden accept='image/jpeg' onChange={(e) => cargarFoto(e, 1)} />
                                </label>
                            ) : (
                                <img id="blah" src="" className="rounded shadow-sm border border-secondary" width={100} height={100} style={{objectFit: 'cover'}} />
                            )}
                            </div>
                            {error.cmpreq !== undefined && idAdjunto == 0 && <small className="text-danger mt-1">{error.cmpreq}</small>}
                        </div>

                        {/* Nombre Completo */}
                        <div className="col-12">
                            <label className="form-label fw-bold text-info"><i className="fa-solid fa-user"></i> Nombre Completo</label>
                            <input 
                            type="text" 
                            className={`form-control bg-dark text-light border-secondary ${error.cmpreq && !nombre ? 'is-invalid' : ''}`}
                            value={nombre} 
                            onChange={(e) => { 
                                if(e.target.value.length < 100){ setError({}); setNombre(e.target.value.toUpperCase()) }
                                else { MsgUtils.msgAdvertencia("Máximo 100 caracteres") }
                            }} 
                            />
                        </div>

                        {/* Género y Edad en la misma fila */}
                        <div className="col-md-6">
                            <label className="form-label fw-bold text-info"><i className="fa-solid fa-venus-mars"></i> Género</label>
                            <select className="form-select bg-dark text-light border-secondary" value={genero} onChange={(e) => { setError({}); setGenero(e.target.value) }}>
                            <option value=''>Seleccione...</option>
                            <option value='M'>Masculino</option>
                            <option value='F'>Femenino</option>
                            </select>
                        </div>

                        <div className="col-md-6">
                            <label className="form-label fw-bold text-info"><i className="fa-solid fa-cake-candles"></i> Edad</label>
                            <input type="number" className="form-control bg-dark text-light border-secondary" value={edad} onChange={(e) => { setError({}); setEdad(e.target.value) }} />
                        </div>

                        {/* Zona y Cargo */}
                        <div className="col-md-6">
                            <label className="form-label fw-bold text-info"><i className="fa-solid fa-map-location-dot"></i> Zona</label>
                            <select className="form-select bg-dark text-light border-secondary" value={idZona} onChange={(e) => { setError({}); setIdZona(e.target.value) }}>
                            <option value={0}>Seleccione Zona</option>
                            {datos.zonas?.map((item, index) => (
                                <option value={item.ID_ZONA} key={index}>{item.DESCRIPCION}</option>
                            ))}
                            </select>
                        </div>

                        <div className="col-md-6">
                            <label className="form-label fw-bold text-info"><i className="fa-solid fa-briefcase"></i> Cargo</label>
                            <select className="form-select bg-dark text-light border-secondary" value={idCargo} onChange={(e) => elegirCargo(e.target.value)}>
                            <option value={0}>Seleccione Cargo</option>
                            {datos.cargo?.map((item, index) => (
                                <option value={item.ID_CARGO} key={index}>{item.DESCRIPCION}</option>
                            ))}
                            </select>
                        </div>

                        {/* Horario}*/}
                        {/* Horario */}
{horarios.length !== 0 && (
    <div className="col-md-6">
        <label className="form-label fw-bold text-info">
            <i className="fa-solid fa-clock me-2"></i>
            Horario
        </label>

        <select
            className="form-select bg-dark text-light border-secondary"
            value={idHora}
            onChange={(e) => {
                setError({});
                setIdHora(e.target.value);
            }}
        >
            <option value={0}>Elija un Horario</option>

            {horarios.map((item, index) => (
                <option
                    key={index}
                    value={item.ID_HORARIO}
                >
                    {item.DESCRIPCION}
                </option>
            ))}
        </select>

        {error.cmpreq !== undefined && idHora == 0 && (
            <div className="text-danger small mt-1">
                {error.cmpreq}
            </div>
        )}
    </div>
)}

                        {/* Contacto */}
                        <div className="col-md-6">
                            <label className="form-label fw-bold text-info"><i className="fa-solid fa-phone"></i> Teléfono Fijo</label>
                            <input type="number" className="form-control bg-dark text-light border-secondary" value={numero} onChange={(e) => { setError({}); setNumero(e.target.value) }} />
                        </div>

                        <div className="col-md-6">
                            <label className="form-label fw-bold text-info"><i className="fa-solid fa-mobile-screen"></i> Celular</label>
                            <input type="number" className="form-control bg-dark text-light border-secondary" value={celular} onChange={(e) => { setError({}); setCelular(e.target.value) }} />
                        </div>

                        {/* Dirección */}
                        <div className="col-12">
                            <label className="form-label fw-bold text-info"><i className="fa-solid fa-house-user"></i> Dirección</label>
                            <textarea 
                            className='form-control bg-dark text-light border-secondary' 
                            rows="2"
                            value={direccion} 
                            onChange={(e) => { 
                                if(e.target.value.length < 200){ setError({}); setDireccion(e.target.value.toUpperCase()) }
                                else { MsgUtils.msgAdvertencia("Máximo 200 caracteres") }
                            }}
                            ></textarea>
                        </div>

                        {/* Hoja de Vida y Captcha */}
                        <div className="col-12 border-top border-secondary pt-3 mt-4">
                            <div className='d-flex align-items-center justify-content-between mb-3'>
                            <div>
                                <label className="form-label fw-bold text-warning mb-0">
                                    <i className="fa-solid fa-file-pdf me-2"></i>Hoja de Vida (PDF)
                                </label>
                            </div>
                            <div>
                                {idAdjuntoDoc == 0 ? (
                                    <label className='btn btn-sm btn-outline-warning'>
                                    <i className="fa-solid fa-upload me-2"></i>Adjuntar PDF
                                    <input type="file" hidden accept='application/pdf' onChange={(e) => cargarDocumento(e, 1)} />
                                    </label>
                                ) : (
                                    <div className="d-flex align-items-center">
                                    <span className="badge bg-success me-2">Archivo cargado</span>
                                    <button className='btn btn-xs btn-danger' onClick={() => setIdAdjuntoDoc(0)}><i className="fa-solid fa-xmark"></i></button>
                                    </div>
                                )}
                            </div>
                            </div>
                        </div>

                        {/** Video de presentacion 

                        <div className="col-12 border-top border-secondary pt-3 mt-3">
                            <div className='d-flex align-items-center justify-content-between mb-2'>
                                <div>
                                    <label className="form-label fw-bold text-danger mb-0">
                                        <i className="fa-solid fa-video me-2"></i>Video de Presentación
                                    </label>
                                    <div className="text-muted small">Formatos aceptados: MP4, WebM (Máx. 20MB)</div>
                                </div>
                                <div>
                                    {idAdjuntoVideo == 0 ? (
                                        <label className='btn btn-sm btn-outline-danger'>
                                            <i className="fa-solid fa-upload me-2"></i>Adjuntar Video
                                            <input 
                                                type="file" 
                                                hidden 
                                                accept="video/mp4,video/webm" 
                                                onChange={(e) => cargarVideo(e)} 
                                            />
                                        </label>
                                    ) : (
                                        <div className="d-flex align-items-center">
                                            <span className="badge bg-success me-2">Video cargado</span>
                                            <button 
                                                className='btn btn-xs btn-danger' 
                                                onClick={() => {
                                                    setIdAdjuntoVideo(0);
                                                    setPreviewVideo(null);
                                                }}
                                            >
                                                <i className="fa-solid fa-trash-can"></i>
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                            
                            {/* Previsualización del video 
                            {previewVideo && (
                                <div className="mt-2 text-center">
                                    <video width="100%" height="auto" controls className="rounded border border-secondary">
                                        <source src={previewVideo} type="video/mp4" />
                                        Tu navegador no soporta la reproducción de video.
                                    </video>
                                </div>
                            )}
                            
                            {error.cmpreq !== undefined && idAdjuntoVideo == 0 && (
                                <div className="text-danger small mt-1">{error.cmpreq}</div>
                            )}
                        </div>*/}

                        <div className="col-12 d-flex flex-column align-items-center py-3">
                            <ReCAPTCHA
                            ref={captchat}
                            theme="dark"
                            sitekey="6LcktxUgAAAAAI7TXwwBes8u9bz79PnCsweM6IL0"
                            onChange={onChange}
                            />
                            {validoCaptcha === false && <span className="badge bg-danger mt-2 p-2">Por favor, completa el captcha</span>}
                        </div>

                        <div className="col-12">
                            {validoCaptcha === true && (
                            <button className='btn btn-success btn-lg w-100 fw-bold shadow' onClick={() => enviarRegistro()}>
                                <i className="fa-solid fa-paper-plane me-2"></i> ENVIAR POSTULACIÓN
                            </button>
                            )}
                        </div>

                        </div>
                    </div>
                    </div>
                </div>
                )}
            {isOpen == false &&
                <div className='container-fluid text-center py-4'>
                    <div className="alert alert-danger fw-bold">
                        Las Postulaciones estan Cerradas
                    </div>
                </div>
            }
            {isFull == true &&
                <div className='container-fluid text-center py-4'>
                    <div className="alert alert-danger fw-bold">
                        La cantidad de postulaciones fue superada, HASTA LA PROXIMA
                    </div>
                </div>
            }
            <ModalCargando show={loading}></ModalCargando>
            <Modal show={modalShow} onHide={() => {
                if (resultado.error != undefined) {
                    setModalShow(false); obtenerDatos(regional);
                } else if (resultado.ok != undefined) {
                    limpiarDatos(); setModalShow(false); obtenerDatos(regional);
                }
            }}
                size='lg' centered
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName={`${resultado.ok !== undefined ? 'bg-success' : resultado.error !== undefined ? 'bg-danger' : 'bg-dark'} bg-gradient`}>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        <div className='text-light'>Mensaje</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body bsPrefix='modal-body m-0 p-0 px-2'>
                    {resultado.ok != undefined && <div className='container-fluid text-center text-light fs-1 fw-bold'>
                        {resultado.ok}
                    </div>}
                    {resultado.error != undefined && <div className='container-fluid text-center  text-light fs-1 fw-bold'>
                        {resultado.error}
                    </div>}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ReclutamientoPersonal